import { call, put } from 'redux-saga/effects';
import GetLeaveActions from '../redux/GetLeaveRedux';
import { api } from './api';


export function* getleavesagas(action: any): Generator<any, void, any> {
  const { leave_id } = action;
  
  const response = yield call(api.getLeave, leave_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetLeaveActions.getLeaveSuccess(response.data));
  } else {
    yield put(GetLeaveActions.getLeaveFailure());
  }
}